import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectionStrategy
} from '@angular/core';
import Splide from '@splidejs/splide';
import { AnimationService } from 'src/app/services/animation/animation.service';
@Component({
  selector: 'app-leadership',
  templateUrl: './leadership.component.html',
  styleUrls: ['./leadership.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LeadershipComponent implements OnInit {
  leaders = [
    {
      id: 2,
      isShown: false,
      name: 'Emmanuel Oyedo',
      title: 'Operations Manager',
      desc: 'Emmanuel O. Oyedo is an experienced Operations Manager at Zumera Property with a remarkable background in management and public safety. He has worked in both public and private sectors, including collaboration with the Edo State Government in the petroleum industry. Known for his exceptional skills in customer relations and unwavering commitment to fostering team spirit, Mr. Emmanuel consistently delivers impeccable results. With a degree in peacebuilding and conflict resolution, he offers a unique problem-solving perspective and prioritizes dedication and a positive work environment.',
      img: 'assets/imgs/managers/ops_manager_2.jpeg',
    },
    {
      id: 3,
      isShown: false,
      name: 'Meck Emmanuel',
      title: 'Chief Financial Officer',
      desc: 'Meck Emmanuel is a Chartered Accountant and Consultant with Corporate Finance experience in multiple industries. He is currently a Senior Partner at Meck Doramen & Associates, a financial advisory firm based in Abuja. Before taking up his current role, Meck was an Investment Analyst at New Frontier Developments Limited were he conducted various Business Intelligence analysis and developed Investment memos, summaries & recommendation for companies in numerous sectors (including the health and real sector). Prior to his engagement with New Frontier Developments Limited, Meck worked in Eronpravid Ventures and Frigoglass at different times as a Finance specialist. At Frigoglass, his core competencies were in Financial Reporting, Budgeting, Internal audit, and Inventory count activities. He is a First-Class graduate of Accounting from the Bingham University and an Associate of the Institute of Chartered Accountants of Nigeria. He is currently completing a master’s degree program in Accounting & Finance from Ahmadu Bello University, Zaria.',
      img: 'assets/imgs/managers/manager_3.jpg',
    },
    {
      id: 4,
      isShown: false,
      name: 'Damilola Keke',
      title: 'Brand & Communications Manager',
      desc: 'Damilola Keke is a seasoned Brand and Marketing Communications Professional with over 10 years experience and expertise in helping brands tell extraordinary stories that connect and impact the bottom line. Having worked in some of the Top Advertising Agencies and biggest Brands in the country, gaining invaluable experience in Copywriting, Strategic thinking, Public Relations, Media Management and Branding, Damilola was part of the creative team for the ACN 2011 Presidential Election, and has also led Sujimoto Group through strategic and sustained communication, to become the standard for Luxury Real Estate in Nigeria. Damilola has consulted for different brands and businesses across various sectors and industries. Damilola has a degree in Communications and Language Art from the prestigious University of Ibadan; with a certification in Crisis Management from the London School of Public Relations.',
      img: 'assets/imgs/managers/manager_4.jpg',
    },
    {
      id: 5,
      isShown: false,
      name: 'Okoroji Chioma Akunna',
      title: 'Project Officer',
      desc: 'Hands-on Project Manager with over nine (9) years extensive experience in Operations management, Project management, Client relationship management, Business Development, Strategy, Recruitment and Selection space. Having an exceptional track record of meeting project timeline goals and within budget, Customer satisfaction record, implementing best practices that improve efficiency, reduce cost and increase productivity, and successfully coordinate a large workforce. Honored for her obsession, dedication, hard work, skills and professional leadership. She holds a Bachelor degree in Engineering, a certified professional of project Management (PMP) and Health Safety and Environment (HSE).',
      img: 'assets/imgs/managers/manager_5.jpeg',
    },
    {
      id: 6,
      isShown: false,
      name: 'Philip Oloche Ukpokwu',
      title: 'Legal Officer',
      desc: 'Philip Oloche, Ukpokwu is a seasoned legal practitioner with a wealth of experience spanning almost a decade in various industries and sectors. With a solid background and experience with investment companies, financial institutions, housing sector, law firms, NGOs, Fintech/Tech organizations and the ministry of justice, he has developed a deep understanding of legal frameworks and the business landscape. As a law expert, Philip has provided invaluable insights into the legal implications of emerging business opportunities and legal implications in technologies, real estate, company compliance with regulators and other law related matters, guiding startups and established companies alike. He has also honed his skills in risk management, HR, and administration, ensuring legal compliance while creating a conducive work environment. With a keen eye for detail, excellent communication skills, and an obsession for delivering results, Philip is a highly sought-after legal practitioner, capable of providing top-notch legal advice and representation to clients. His dedication to excellence and commitment to delivering results have earned him a reputation as a trusted legal advisor in the industry. He is also a trained and certified customer service personnel, social media manager, digital marketer and a musicologist. He is obsessed about helping brands and business owners, avoid costly legal battles, and lay foundations for long-term growth; including organizations, companies, NGOs, entrepreneurs and executives who are pursuing their obsessions and the advancement of innovation. He has handled an array of legal matters, representing the interests of corporate and individual client on complete issues, agreement and transactions. ',
      img: 'assets/imgs/managers/manager_6.jpeg',
    },
  ];
  backgroundImageUrl: any;
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;
  @ViewChildren('leftReveal') leftReveal!: QueryList<ElementRef>;
  @ViewChildren('rightReveal') rightReveal!: QueryList<ElementRef>;

  constructor(private animate: AnimationService) {}

  ngOnInit(): void {
    this.splideCarousel();
  }

  ngAfterViewInit(): void {
    const elements = this.textContent.toArray().map((el) => el.nativeElement);
    const rightElems = this.rightReveal.toArray().map((el) => el.nativeElement);
    const leftElems = this.leftReveal.toArray().map((el) => el.nativeElement);
    if (elements) {
      this.animate.fadeInElementsImmediate(elements, 0.05);
      console.log('1st');
    }
    this.animate.revelText(leftElems);
    this.animate.revelTextRight(rightElems);
  }
  toggleRead(card: any) {
    card.isShown = !card.isShown;
  }

  splideCarousel() {
    var splide = new Splide('.splide', {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      focus: 'center',
      autoplay: true,
      pagination: false,
      arrows: false,
      breakpoints: {
        640: {
          perPage: 2,
          gap: '.7rem',
          height: '6rem',
        },
        480: {
          perPage: 1,
          padding: `5rem`,
          gap: '.7rem',
          height: '500px',
        },
        380: {
          perPage: 1,
          padding: `2rem`,
          gap: '.5rem',
          height: '500px',
        },
      },
    });

    var bar = splide.root.querySelector<HTMLDivElement>(
      '.my-carousel-progress-bar'
    );

    // Updates the bar width whenever the carousel moves:
    splide.on('mounted move', function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);

      if (bar) {
        bar.style.width = String(100 * rate) + '%';
      }
    });

    splide.mount();
  }
}
